import { TermsAndPolicies } from '../../data/types';
import { useAppDispatch } from '../hooks';
import { setAcceptedTOSAction, setTermsAndPoliciesAction } from '../reducers/termsAndPoliciesReducer';

export const useTermsAndPoliciesActions = () => {

    const dispatch = useAppDispatch();

    const setTermsAndPolicies = (termsAndPolicies: TermsAndPolicies) => {
        dispatch(setTermsAndPoliciesAction(termsAndPolicies));
    }
    const setAcceptedTOS = (accepted: boolean) => {
        dispatch(setAcceptedTOSAction(accepted));
    }
    
    return {
        setTermsAndPolicies,
        setAcceptedTOS
    };
}